import React from 'react';

function TodaysDate() {
    return (
        <div>
            <div className="text-sm text-gray-400">
                {new Date().toLocaleDateString('en-za', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric',
                })}
            </div>
        </div>
    );
}

export default TodaysDate;
